module.exports = __webpack_public_path__ + "static/media/advance_tool_img.97c8954f.png";